"use client"

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog"
import { Button } from "../ui/button"
import { Clock, FileText, CalendarDays } from "lucide-react"
import { useNavigate } from "react-router-dom"

interface PendingApprovalsSummaryModalProps {
  isOpen: boolean
  onClose: () => void
  pendingTimesheetCount: number
  pendingLeavesCount: number
}

export function PendingApprovalsSummaryModal({
  isOpen,
  onClose,
  pendingTimesheetCount,
  pendingLeavesCount,
}: PendingApprovalsSummaryModalProps) {
  const navigate = useNavigate()

  const goToTimesheetApprovals = () => {
    onClose()
    navigate("/pending-approvals/timesheet")
  }

  const goToLeaveApprovals = () => {
    onClose()
    navigate("/pending-approvals/leave")
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-white border border-gray-200 rounded-lg shadow-lg p-0">
        <DialogHeader className="border-b border-gray-200 px-6 pt-6 pb-4">
          <DialogTitle className="text-xl font-semibold text-gray-900 flex items-center gap-2">
            <Clock className="w-5 h-5 text-orange-600" />
            Pending Approvals
          </DialogTitle>
        </DialogHeader>

        <div className="px-6 py-4 space-y-3">
          <button
            onClick={goToTimesheetApprovals}
            className="w-full flex items-center justify-between p-4 rounded-lg border-2 border-orange-200 hover:bg-orange-50 hover:shadow-md transition-shadow text-left"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                <FileText className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="text-lg font-bold text-gray-900">{pendingTimesheetCount}</div>
                <div className="text-sm text-gray-600">Timesheet{pendingTimesheetCount !== 1 ? "s" : ""} awaiting review</div>
              </div>
            </div>
          </button>

          <button
            onClick={goToLeaveApprovals}
            className="w-full flex items-center justify-between p-4 rounded-lg border-2 border-blue-200 hover:bg-blue-50 hover:shadow-md transition-shadow text-left"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                <CalendarDays className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="text-lg font-bold text-gray-900">{pendingLeavesCount}</div>
                <div className="text-sm text-gray-600">Leave request{pendingLeavesCount !== 1 ? "s" : ""} awaiting review</div>
              </div>
            </div>
          </button>
        </div>

        <div className="flex justify-end px-6 pb-6 pt-2">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
